module.exports = __webpack_public_path__ + "static/ishangaur-9dcee4ac6412b93c12c700520b63019a.jpg";